<template>
    <div id="app" class="">
        <div class="app-main">
            <div class="app_container">
                <div class="single_content">
                    <div class="course_buy_info">
                        <div class="app_header">
                            <div class="app_header_left">
                                <i class="el-icon font24 cp" @click="goFor">
                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                                        <path fill="currentColor"
                                              d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z">
                                        </path>
                                    </svg>
                                </i>
                                <div class="course_title tx-ov">{{majorName}}</div>
                                <div class="icon_btn_list">
                                    <!--<div class="icon_btn" >
                    <span class="iconfont pdr7 icon-collection" ></span>
                    <span class="icon_text" >收藏</span>
                  </div>
                  <div class="icon_btn">
                    <span class="iconfont icon-share pdr7" ></span>
                    <span class="icon_text" >分享</span>
                  </div>-->
                                </div>
                            </div>
                        </div>


                        <div class="section-list" :style=Style>
                            <div class="operator">
                                <div class="op chapter" @click="clickChap"><i class="el-icon-notebook-2"></i>章节</div>
                                <!--<div class="op notes"><i class="layui-icon"></i>tt</div>
                  <div class="op question"><i class="layui-icon"></i>tt</div>
                  <a href="#code_down_li">
                    <div class="op code_down">
                    <i class="layui-icon layui-icon-download-circle">
                    </i>tt</div>
                  </a>
                  <div class="op" onclick="advice_data(33085)">
                    <i class="layui-icon layui-icon-chat"></i>tt
                  </div>
                  <a href="/about/donate.html" target="_blank">
                    <div class="op" style="color:#fff; background-color: red;">
                      <i class="layui-icon layui-icon-rmb"></i>tt
                    </div>
                  </a>-->
                            </div>
                            <div class="nano has-scrollbar">
                                <div class="nano-content" tabindex="0" style="right: -17px;">
                                    <!--<h3>{{majorName}}</h3>-->
                                    <ul v-for="(i,k) in videoList" :key="k">
                                        <li class="sec-title">
                                            <span>{{k}}</span>
                                        </li>
                                        <li v-for="(i1,k1) in i.videoList" :key="k1" style="cursor: pointer;">

                                            <a @click="clickPlay(k,k1,i1.path,i1.id,i1.canPlay)"
                                               disabled="true"
                                               :title=i1.title>

                                                <em class="icon-code"></em>

                                                {{i1.title}}

                                                <span style="border: 1px solid orange;color: orange;font-size: 12px" v-if="i1.canPlay">免费</span>
                                            </a>

                                            <i v-if="(k+k1) == changeColor || i1.id==currentVideoId">正在学<em class="icon-clock"></em></i>

                                        </li>
                                    </ul>
                                </div>
                                <div class="nano-pane">
                                    <div class="nano-slider" style="height: 141px; transform: translate(0px, 0px);">
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="app_content">
                            <div class="app_video">
                                <!--<div class="video_stop" @click="play">
                  <img alt="播放" src="../../assets/img/play.23de0d2c.svg" >
                </div>-->
                                <div id="player" class="video_content">
                                    <div class="pv-video-player pv-skin_blue-39190823 pv-skin_blue-player pv-paused">
                                        <div class="pv-video-wrap">
                                            <div class="pv-log-message"></div>
                                            <div class="pv-log-error" style="display: none;">
                                                <div class="pv-log-errorIcon"></div>
                                                <div class="pv-log-errormsg"></div>
                                            </div>
                                            <video id="videoPlayer"
                                                   ref="player"
                                                   class="video-js"
                                                   preload="preload"
                                                   :poster="poster"
                                                   controlslist="nodownload"
                                                   controls
                                                   @play="onPlayerPlay($event)"
                                                   @ended="onPlayerEnded($event)"
                                                   @pause="onPlayerPause($event)"
                                                   @loadeddata="onPlayerLoadeddata($event)"

                                                   oncontextmenu="return false">

                                            </video>


                                            <!-- <rxwp>
                      <wktg>手机尾号7170的用户</wktg>
                    </rxwp>-->

                                            <!--  <o-span class="pv-opa-tk" style="top: 403px; left: 1433px;"></o-span>-->

                                            <div class="pv-loading" style="display: none;">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>

                                            <div class="pv-cover"
                                                 style="background-image: url(https://img.videocc.net/public/audio_default_b.png); background-size: 100% 100%; display: none;">
                                                <div style="opacity: 0.7"></div>
                                                <span class="pv-icon-btn-play pv-iconfont"
                                                      style="display: block;"></span>
                                            </div>

                                        </div>
                                        <!--<div class="pv-skin-blue pv-video-bottom pv-subtitle-hide pv-base-control pv-stream-hide pv-first-h"
                                             style="overflow: hidden;">
                                            <div class="pv-progress-wrap">
                                                <div class="pv-progress-touch"></div>
                                                <div class="pv-progress-bg">
                                                    <div class="pv-progress-buffer" style="transform: scaleX(1);"></div>
                                                    <div class="pv-progress-current">
                                                        <div class="pv-progress-current-bg" style="width: 44.3202%;">
                                                        </div>
                                                        <span class="pv-progress-target"></span>
                                                    </div>
                                                    <div class="pv-progress-key"></div>
                                                </div>
                                            </div>
                                        </div>-->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="el-overlay" style="z-index: 2027; display: none;">
                    <div aria-modal="true" aria-labelledby="el-id-100-21" aria-describedby="el-id-100-22"
                         class="el-drawer ttb share_box_content" role="dialog" style="height: 30%;">
                        <span class="el-drawer__sr-focus" tabindex="-1"></span>
                        <header class="el-drawer__header">
                            <span id="el-id-100-21" role="heading" class="el-drawer__title"></span>
                            <button aria-label="el.drawer.close" class="el-drawer__close-btn" type="button">
                                <i class="el-icon el-drawer__close">
                                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                                        <path fill="currentColor"
                                              d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z">
                                        </path>
                                    </svg>
                                </i>
                            </button>
                        </header>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getVideoList
    } from "../../api/moudles/user";

    import Videojs from "video.js";
    import md5 from "js-md5";


    export default {
        name: "videoplay",

        data() {
            return {
                majorName: '',
                major_id: '',
                claId: '',
                currentRate: '1x',
                scId: '',
                currentVideoId: '',
                ClassName: 'pv-active',
                ClassName2: '',
                poster: 'https://img.videocc.net/public/audio_default_b.png',
                videoList: [],
                nowPlayVideoUrl: "",
                isProcess: false,
                isDisplay: true,
                Style: "right: 0px",
                changeColor: '',
                player: null,
                free_number: null,
                freeStudy: null,
                classMajorID: null,

            }
        },
        components: {

        },


        mounted() {

            //this.initVideo(this.nowPlayVideoUrl);
        },

        computed: {

        },

        beforeDestroy() {

            this.newbeforeDestroy()

        },

        created() {

            this.majorName = this.$route.query.majorName //课程名称
            this.free_number = this.$route.query.free_number //免费试听数量
            this.major_id = this.$route.query.major_id //课程编号
            this.freeStudy = this.$route.query.freeStudy //是否有免费试听
            this.claId = this.$route.query.claId  //班级id
            this.classMajorID = this.$route.query.id  //class_major表的id

            this.fetchData()

            /*document.onkeydown = () => {
              //禁用F12
              if (window.event && window.event.keyCode == 123) {
                return false;
                //禁用ctrl+shift+i,
              } else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
                return false;
                //屏蔽Shift+F10
              } else if (window.event.shiftKey && window.event.keyCode == 121) {
                return false;
              }
            };
            // 禁用右键
            document.oncontextmenu = new Function("event.returnValue=false");*/



        },

        watch: {
            nowPlayVideoUrl(newVal) {
                //this.initVideo(newVal);
                console.log(newVal)
            }
        },

        methods: {

            // 播放回调
            onPlayerPlay(player) {
                console.log('player play!', player)
            },

            onPlayerLoadeddata(player) {
                console.log('player play---!', player)
            },

            onPlayerPause(player){
                console.log('player end!', player)

            },

            onPlayerEnded(player) {
                console.log('player end!', player)
            },

            initVideo(nowPlayVideoUrl) {
                // 这些options属性也可直接设置在video标签上

                console.log('调用了初始化。。。')

                let options = {}

                if (nowPlayVideoUrl.indexOf('.m3u8') == -1) {

                    options = {
                        autoplay: true, // 设置自动播放
                        controls: true, // 显示播放的控件
                        sources: [
                            // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
                            {
                                src: nowPlayVideoUrl,
                                type: "video/mp4" // 告诉videojs,这是一个hls流
                            }
                        ]
                    };

                } else {
                    options = {
                        autoplay: true, // 设置自动播放
                        controls: true, // 显示播放的控件
                        sources: [
                            // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
                            {
                                src: nowPlayVideoUrl,
                                type: "application/x-mpegURL" // 告诉videojs,这是一个hls流
                            }
                        ]
                    };
                }


                // videojs的第一个参数表示的是，文档中video的id
                const myPlyer = Videojs("videoPlayer", options, function onPlayerReady() {
                    console.log("onPlayerReady 中的this指的是：", this); // 这里的this是指Player,是由Videojs创建出来的实例
                    console.log(myPlyer === this); // 这里返回的是true
                });

                this.player = myPlyer


            },


            newbeforeDestroy() {
                if (this.player) {
                    this.player.dispose(); // Removing Players,该方法会重置videojs的内部状态并移除dom
                }
            },

            clickChap() {

                if (this.isDisplay) {

                    this.isDisplay = false

                    this.Style = "right: 0px"
                } else {

                    this.isDisplay = true

                    this.Style = "right: 0px;width: 400px;"
                }

            },

            clickPlay(k, k1, path, id,canPlay) {

                if(canPlay == 0){ //不允许进行学习，超出免费数量
                    this.$message.error("请先加入学习哦");

                    return false
                }

                this.changeColor = k + k1   //标识已在学
                this.currentVideoId = id
                this.nowPlayVideoUrl = path



                this.initVideo(this.nowPlayVideoUrl); //初始化视频

                console.log(this.nowPlayVideoUrl, "改变了");

                if (path.indexOf('.m3u8') == -1) {

                    this.player.src([{
                        src: path,
                        type: 'video/mp4'
                    }])

                } else {
                    this.player.src([{
                        src: path,
                        type: "application/x-mpegURL" // 告诉videojs,这是一个hls流
                    }])
                }

                this.player.play()

            },

            fetchData() {


                let token = localStorage.getItem('userToken')

                let time = parseInt(new Date().getTime() / 1000)

                getVideoList({

                    data: {
                        major_id: this.major_id,
                        userToken: token,
                        claId: this.claId,
                        freeStudy :1,
                        classMajorID :this.classMajorID,
                        time:time ,
                        sign: md5(this.major_id + this.claId + token +time+'video')
                    },

                    success: (res) => {

                        console.log(8888899999)
                        console.log(res)

                        this.videoList = res.data.videos

                        if(res.data.videoPath){
                            this.nowPlayVideoUrl = res.data.videoPath
                            this.currentVideoId = res.data.videoId
                            this.initVideo(this.nowPlayVideoUrl);
                        }

                    }

                })

            },

            goFor() {
                history.back(-1)
            }
        }
    }
</script>

<style scoped>
    .video-js {
        position: relative !important;
    }

    #app {
        position: relative;
        background-color: #f6f8fb;
    }

    #app {
        height: 100vh;
        overflow: auto;
    }

    html,
    body,
    #app {
        margin: 0;
        padding: 0;
    }


    #videoPlayer {
        width: 100%;
        height: calc(100vh - 40px);
        overflow: hidden;
    }

    .layui-rate,
    li {
        list-style: none;
    }

    .app-main {
        height: 100vh;
        background-color: #f6f8fb;
        overflow: hidden;
        padding-top: 0;
        padding-bottom: 0;
    }

    .app_container {
        padding-bottom: 0;
    }

    .course_buy_info {
        width: 100%;
        height: 100vh;
        position: relative;
    }

    .course_buy_info .app_header {
        height: 51px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 30px;
        padding-right: 10px;

        background: #FFFFFF;
        filter: drop-shadow(0px 5px 15px rgba(54, 41, 183, .06));
        position: relative;
        z-index: 999;
    }

    .course_buy_info .app_header .app_header_left {
        display: flex;
        align-items: center;
    }

    .pv-icon-volumeon:before {
        content: "󾘍";
    }

    .course_buy_info .app_header .app_header_left .el-icon {
        width: 30px;
        height: 30px;
        margin-right: 20px;
        cursor: pointer;
    }

    .font24 {
        font-size: 24px;
    }

    .el-icon {
        --color: inherit;
        height: 1em;
        width: 1em;
        line-height: 1em;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: relative;
        fill: currentColor;
        color: var(--color);
        font-size: inherit;
    }

    .pv-controls button {
        outline: none;
        border: 0;
        vertical-align: top;
        background-color: transparent;
        text-align: center;
        color: #fff;
        width: 34px;
        cursor: pointer;
        display: inline-block;
        height: 100%;
        font-size: 14px;
        font-family: "helvetica neue", "hiragino sans gb", "tahoma", "microsoft yahei ui", "microsoft yahei", "simsun", "sans-serif";
    }

    .pv-icon-settings:before {
        content: "󾘉";
    }

    .el-icon svg {
        height: 1em;
        width: 1em;
    }

    .pv-icon-pause:before {
        content: "󾘆";
    }

    .pv-icon-btn-play:before {
        content: "󾠼";
    }

    .course_buy_info .app_header .course_title {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        max-width: 485px;
    }

    .tx-ov {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .course_buy_info .app_header .icon_btn_list {
        display: flex;
        align-items: center;
        margin-left: 30px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #999;
    }

    .course_buy_info .app_header .icon_btn .pdr7 {
        padding-right: 7px;
    }

    .iconfont {
        font-family: iconfont !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .course_buy_info .app_header .icon_btn+.icon_btn {
        margin-left: 30px;
    }

    .el-popper[data-popper-placement^=bottom]>.el-popper__arrow {
        top: -5px;
    }

    .el-popper__arrow {
        position: absolute;
        width: 10px;
        height: 10px;
        z-index: -1;
    }

    .section-list {
        /*  z-index: 998;
    position: absolute;
    top: 0;
    right: 0;
    background-color: #1c1f21;
    box-shadow: 0 5px 15px #3629b70f;
    width: 66px;
    height: 100%;
    padding-top: 60px;
    box-sizing: border-box;
    overflow: auto;*/

        position: absolute;
        margin-top: 51px;
        top: 0;
        z-index: 999;

        height: 100%;
        background: #14191e;

    }

    .section-list .operator {
        position: absolute;
        top: 50%;
        left: -50px;
        margin-top: -192px;
        width: 50px;
    }


    .section-list .operator .op {
        position: relative;
        height: 60px;
        line-height: 82px;
        font-size: 12px;
        text-align: center;
        color: #B5B9BC;
        background-color: #363C40;
        cursor: pointer;
        margin: 2px 0;
    }


    .section-list .operator .op:hover,
    .section-list .operator .op.light {
        background-color: #f01400;
        color: #fff;
    }


    .section-list .operator .op i {
        position: absolute;
        display: block;
        font-size: 16px;
        text-align: center;
        border-radius: 3px 0 0 3px;
        top: 12px;
        width: 50px;
        height: 30px;
    }

    .nano {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }


    .section-list .nano .nano-content {
        right: -17px !important;
        outline: none !important;

    }

    .nano .nano-content {
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        top: 0;
        right: 0;
        bottom: 30px;
        left: 0;
    }

    .section-list h3 {
        color: #b5b9bc;
        line-height: 20px;
        font-size: 16px;
        text-align: left;
        margin-top: 20px;
        margin-right: 30px;
    }

    .section-list ul {
        margin-top: 15px;
        margin-right: 30px;
    }


    .section-list li.sec-title {
        padding-bottom: 9px;
    }

    .section-list li {
        margin-top: 5px;
    }

    .section-list li span {
        font-size: 14px;
        color: #787d82;
        line-height: 20px;
        text-align: left;
    }

    .section-list li a {
        font-size: 12px;
        color: #787d82;
        line-height: 20px;
        text-align: left;
        margin-left: 15px;
    }

    .section-list li i {
        float: right;
        font-size: 12px;
        line-height: 20px;
        text-align: left;
        color: #00b33b;
    }

    em {
        font-style: normal;
    }

    a:link,
    :visited,
    ins {
        text-decoration: none !important;
    }


    .nano .nano-pane {
        background: rgba(0, 0, 0, .25);
        position: absolute;
        width: 10px;
        right: 0;
        top: 0;
        bottom: 0;
        visibility: hidden\9;
        opacity: .01;
        -webkit-transition: .2s;
        -moz-transition: .2s;
        -o-transition: .2s;
        transition: .2s;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        border-radius: 5px;
    }

    .app_menu_item {
        width: 100%;
        height: 75px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        color: #999;
    }

    /*  .app_menu_item .iconfont {
    font-size: 24px;
  }*/
    .iconfont {
        font-family: iconfont !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .iconfont {
        cursor: pointer;
    }

    .iconfont {
        font-family: iconfont !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .app_menu_item .iconfont {
        font-size: 24px;
    }

    .app_content {
        width: calc(100% - 0px);
        height: calc(100% - 66px);
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000000;
    }

    .app_video {
        width: 100%;
        height: 100%;
        overflow: auto;
        padding-bottom: 30px;
        position: relative;
        background: #000000;
    }

    .app_video .video_stop {
        position: fixed;
        right: 366px;
        bottom: 100px;
        z-index: 99;
        max-height: 64px;
        cursor: pointer;
    }

    img,
    video {
        max-width: 100%;
        height: auto;
    }

    img,
    canvas,
    iframe,
    video {
        display: block;
        vertical-align: middle;
    }

    .video_content {
        width: 100%;
        height: 100%;

    }

    .bplayer-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        background: #000;
        overflow: hidden;
        background-position: center center;
        background-size: cover;
    }

    .bplayer-wrap .bplayer-media-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .bplayer-wrap .bplayer-media-wrap .bplayer-video {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
    }


    .bplayer-wrap .bplayer-feature-wrap {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .bplayer-control-wrap {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        overflow: hidden;
        user-select: none;
        z-index: 9;
    }

    .bplayer-wrap.hide-controller .bplayer-control-wrap .bplayer-title {
        top: -40px;
    }

    .bplayer-control-wrap .bplayer-title {
        left: 0;
        right: 0;
        top: 0;
        position: absolute;
        height: 40px;
        line-height: 40px;
        color: #fff;
        text-align: center;
        font-size: 18px;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.3));
        transition: top .3s;
    }

    .bplayer-wrap.hide-controller .bplayer-control-wrap .bplayer-control-bar {
        bottom: -40px;
    }


    .bplayer-control-wrap .bplayer-control-bar {
        z-index: 1;
        position: absolute;
        height: 40px;
        width: 100%;
        padding: 0 5px;
        bottom: 0;
        box-sizing: border-box;
        background: rgba(0, 0, 0, .4);
        backdrop-filter: blur(8px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        backdrop-filter: none;
        transition: bottom .3s;
    }

    .bplayer-control-wrap .bplayer-control-bar .left,
    .bplayer-control-wrap .bplayer-control-bar .right {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex-shrink: 0;
        height: 100%;
        color: rgba(255, 255, 255, .8);
    }

    .bplayer-control-wrap .bplayer-control-bar .left .icon,
    .bplayer-control-wrap .bplayer-control-bar .right .icon {
        width: 32px;
        height: 32px;
        cursor: pointer;
        margin: 0 5px;
        display: inline-block;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .spliter,
    .bplayer-control-wrap .bplayer-control-bar .right .spliter {
        display: inline-block;
        margin: 0 4px;
    }

    .bplayer-control-wrap .bplayer-control-bar .bplayer-progress-bar.absolute {
        position: absolute;
        left: 0;
        right: 0;
        top: -4px;
    }

    .bplayer-control-wrap .bplayer-control-bar .bplayer-progress-bar .bplayer-progress-loaded {
        height: 100%;
        background: rgba(255, 255, 255, .6);
        position: absolute;
        left: 0;
        width: 0;
        border-radius: 0px 100px 100px 0px;
    }

    .bplayer-control-wrap .bplayer-control-bar .bplayer-progress-bar .bplayer-progress-played {
        height: 100%;
        background: #1795ff;
        background: var(--brand-primary, #1795ff);
        position: absolute;
        left: 0;
        width: 0;
        border-radius: 0px 100px 100px 0px;
    }


    .bplayer-control-wrap .bplayer-control-bar .bplayer-progress-bar .bplayer-show-thumbnails .cursor {
        position: absolute;
        left: 50%;
        width: 10px;
        transform: translateX(-50%);
    }

    .bplayer-control-wrap .bplayer-control-bar .bplayer-progress-bar .bplayer-show-thumbnails .time {
        position: absolute;
        top: -40px;
        left: 50%;
        transform: translateX(-50%);
        height: 24px;
        line-height: 24px;
        padding: 2px 5px;
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        background-color: rgba(0, 0, 0, .6);
    }

    .bplayer-control-wrap .bplayer-control-bar .left,
    .bplayer-control-wrap .bplayer-control-bar .right {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex-shrink: 0;
        height: 100%;
        color: rgba(255, 255, 255, .8);
    }



    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text {
        width: 40px;
        margin: 0 5px;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text span,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text span {
        height: 32px;
        line-height: 32px;
    }

    .bplayer-control-wrap .bplayer-control-bar .bplayer-control[data-show="0"]>.bplayer-option-list {
        width: 0 !important;
        opacity: 0 !important;
        overflow: hidden !important;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list {
        position: absolute;
        border-radius: 4px;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        background: rgba(0, 0, 0, .4);
        backdrop-filter: blur(8px);
        overflow: hidden;
    }


    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list .bplayer-option-item,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list .bplayer-option-item {
        height: 36px;
        width: 100%;
        line-height: 36px;
        color: #fff;
        min-width: 72px;
        padding: 0 12px;
        box-sizing: border-box;
        white-space: nowrap;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }



    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text {
        width: 40px;
        margin: 0 5px;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control.text span,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control.text span {
        height: 32px;
        line-height: 32px;
    }

    .bplayer-control-wrap .bplayer-control-bar .bplayer-control[data-show="0"]>.bplayer-option-list {
        width: 0 !important;
        opacity: 0 !important;
        overflow: hidden !important;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list {
        position: absolute;
        border-radius: 4px;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        background: rgba(0, 0, 0, .4);
        backdrop-filter: blur(8px);
        overflow: hidden;
    }


    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        position: relative;
        text-align: center;
        cursor: pointer;
    }


    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list.volume,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list.volume {
        width: 60px;
        height: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list.volume .volume-value,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list.volume .volume-value {
        font-size: 16px;
        color: #fff;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list.volume .bplayer-volume-bar,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list.volume .bplayer-volume-bar {
        width: 8px;
        height: 140px;
        background: rgba(255, 255, 255, .4);
        border-radius: 5px;
        position: relative;
        margin-top: 12px;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list.volume .bplayer-volume-bar-active,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list.volume .bplayer-volume-bar-active {
        width: 8px;
        background: #1795ff;
        background: var(--brand-primary, #1795ff);
        border-radius: 5px;
        position: absolute;
        bottom: 0;
        height: 98px;
        cursor: pointer;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        position: relative;
        text-align: center;
        cursor: pointer;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .icon,
    .bplayer-control-wrap .bplayer-control-bar .right .icon {
        width: 32px;
        height: 32px;
        cursor: pointer;
        margin: 0 5px;
        display: inline-block;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list.settings,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list.settings {
        left: auto;
        right: 0;
        transform: translateX(0);
        font-size: 14px;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list .bplayer-option-item.space-between,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list .bplayer-option-item.space-between {
        justify-content: space-between;
    }


    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control .bplayer-option-list .bplayer-option-item .bplayer-switcher,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control .bplayer-option-list .bplayer-option-item .bplayer-switcher {
        width: 40px;
        height: 24px;
        background: rgba(255, 255, 255, .2);
        border-radius: 12px;
        position: relative;
        margin-left: 10px;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .bplayer-control,
    .bplayer-control-wrap .bplayer-control-bar .right .bplayer-control {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        position: relative;
        text-align: center;
        cursor: pointer;
    }

    .bplayer-control-wrap .bplayer-control-bar .left .icon,
    .bplayer-control-wrap .bplayer-control-bar .right .icon {
        width: 32px;
        height: 32px;
        cursor: pointer;
        margin: 0 5px;
        display: inline-block;
    }

    .bplayer-control-wrap .bplayer-control-full {
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .bplayer-control-wrap .bplayer-control-full .icon-center {
        display: inline-block;
        width: 128px;
        height: 128px;
        position: relative;
        top: 25px;
    }

    .bplayer-wrap .bplayer-feature-wrap .bplayer-info-wrap {
        pointer-events: none;
        overflow: hidden;
    }

    .bplayer-wrap .bplayer-feature-wrap .bplayer-info-wrap .bplayer-action-tip.hide {
        opacity: 0;
    }


    .bplayer-wrap .bplayer-feature-wrap .bplayer-info-wrap .bplayer-action-tip {
        position: absolute;
        bottom: 60px;
        left: 12px;
        padding: 6px 16px;
        color: #fff;
        text-align: center;
        background-color: rgba(0, 0, 0, .6);
        font-size: 14px;
        border-radius: 4px;
        transition: opacity .2s;
    }


    .bplayer-wrap .bplayer-feature-wrap .bplayer-debug-wrap {
        z-index: 9;
        width: 0;
        height: 0;
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .6);
        opacity: 0;
        color: #fff;
        padding: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        pointer-events: none;
    }

    .bplayer-wrap .bplayer-feature-wrap .bplayer-debug-wrap .bplayer-debug-info {
        width: 48%;
        overflow: auto;
    }


    .bplayer-wrap .bplayer-feature-wrap .bplayer-custom-wrap {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-size: cover;
        background-position: center center;
    }

    .bplayer-wrap .bplayer-eye-protection {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 0;
        z-index: 9999;
        background-color: #ffb139;
        opacity: .07;
        pointer-events: none;
        transition: width .3s;
    }

    .pv-skin_blue-player.pv-paused .pv-skin-blue.pv-video-bottom {
        height: 63px;
        overflow: visible !important;
    }


    .pv-skin-blue.pv-video-bottom {
        height: 0;
        padding-top: 15px;
        overflow: hidden;
        transition: height .4s;
    }

    .pv-video-bottom {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        -ms-user-select: none;
        user-select: none;
        z-index: 2;
    }

    .pv-video-player * {
        box-sizing: border-box;
    }

    video.pv-video {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #000;
        z-index: auto;
    }

    .pv-skin-blue .pv-controls {
        color: #fff;
        position: relative;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 16, 27, .7);
        background-clip: content-box;
    }

    .pv-controls {
        box-sizing: border-box;
        font-family: "helvetica neue", "hiragino sans gb", "tahoma", "microsoft yahei ui", "microsoft yahei", "simsun", "sans-serif";
        font-size: 14px;
    }

    .pv-skin-blue .pv-controls .pv-controls-left {
        font-size: 12px;
        position: absolute;
        left: 10px;
        top: 0;
        height: 48px;
    }

    .pv-skin-blue .pv-controls .pv-controls-left>* {
        display: inline-block;
        height: 100%;
        vertical-align: top;
        position: relative;
    }

    .pv-skin-blue .pv-controls .pv-time-wrap {
        line-height: 48px;
    }


    .pv-skin-blue .pv-controls .pv-controls-right {
        position: absolute;
        right: 10px;
        top: 0;
        height: 48px;
    }

    .pv-skin-blue .pv-controls .pv-controls-right>* {
        display: inline-block;
        height: 100%;
        vertical-align: top;
        position: relative;
    }

    .pv-skin-blue .pv-controls .pv-btn-radius button {
        padding: 0;
        font-size: 12px;
        color: #fff !important;
        white-space: nowrap;
        width: auto;
    }

    .pv-skin-blue .pv-controls .pv-btn-radius button>span {
        min-width: 60px;
        padding: 0 10px;
        line-height: 24px;
        display: inline-block;
        background-color: rgba(0, 0, 0, .35);
        border-radius: 12px;
    }

    .pv-control-wrap-style {
        z-index: -1;
        opacity: 0;
    }

    .pv-control-wrap-style,
    .pv-control-wrap-style2 {

        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-bottom: -4px;
        padding-bottom: 15px;
        -ms-transform: translateX(-50%);
        transform: translateX(-50%);
        transition: opacity .5s;
    }

    .pv-controls * {
        box-sizing: border-box;
    }

    .pv-skin-blue .pv-rate-select {
        position: relative;
        width: 64px;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
    }

    .pv-skin-blue .pv-rate-select>div:first-child {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }


    .pv-skin-blue .pv-rate-select>div {
        padding: 6px 0;
        margin-bottom: 1px;
        cursor: pointer;
        text-align: center;
    }


    .pv-skin-blue .pv-setting-select-wrap {
        min-width: 168px;
        right: -30px;
        left: auto !important;
        -ms-transform: translateX(0) !important;
        transform: translateX(0) !important;
    }


    .pv-skin-blue .pv-setting-select {
        font-size: 12px;
        position: relative;
    }

    .video-active {
        color: #3d7fff;
    }

    .pv-skin-blue .pv-setting-select>div:first-child {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .pv-skin-blue .pv-setting-select .pv-setting-tip {
        color: #8f8f8f;
        margin-bottom: 6px;
    }

    .pv-skin-blue .pv-setting-choose.pv-subtitle-select {
        min-width: 250px;
    }

    .pv-skin-blue.pv-subtitle-hide .pv-stream-select-wrap {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .pv-skin-blue.pv-stream-hide .pv-stream-select-wrap {
        display: none !important;
    }

    .pv-skin-blue .pv-setting-select .pv-setting-choose>span {
        display: inline-block;
        margin-right: 15px;
        cursor: pointer;
    }

    .pv-skin-blue.pv-stream-hide.pv-subtitle-hide .pv-stream-select-wrap+div {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
    }

    .pv-fullscreen-tip,
    .pv-fullscreen-page-tip,
    .pv-pip-tip {
        margin-bottom: 11px;
        font-size: 12px;
        line-height: 30px;
        padding: 0 9px;
        border-radius: 4px;
        text-align: center;
        white-space: nowrap;
    }


    .pv-fullscreen-page-wrap,
    .pv-pip-wrap {
        display: none !important;
    }


    .pv-dm-wrap>button {
        display: none;
        font-size: 15px;
        padding-left: 7px;
        padding-right: 7px;
        width: 28px;
    }

    .pv-danmu-tip {
        margin-bottom: 11px;
        font-size: 12px;
        line-height: 30px;
        padding: 0 9px;
        border-radius: 4px;
        text-align: center;
        white-space: nowrap;
    }

    .pv-skin-blue .pv-volume-slider {
        position: relative;
        padding: 9px 13px;
        cursor: pointer;
        border-radius: 4px;
    }

    img,
    video {
        max-width: 100%;
        height: auto;
    }

    img,
    canvas,
    iframe,
    video {
        display: block;
        vertical-align: middle;
    }

    /**滚动条的宽度*/
    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    /*滚动条的滑块*/
    ::-webkit-scrollbar-thumb {
        background-color: rgb(185, 221, 255);
        border-radius: 5px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: rgba(24, 144, 255, .8);
    }


    ::v-deep .video-js .vjs-big-play-button{
        font-size: 3em;
        line-height: 1.5em;
        height: 1.63332em;
        width: 3em;
        display: block;
        position: absolute;
        right: 50px !important;
        top: unset;
        bottom: 100px !important;
        left: unset;
        padding: 0;
        cursor: pointer;
        opacity: 1;
        border: 0.06666em solid #fff;
        background-color: #2B333F;
        background-color: rgba(43, 51, 63, 0.7);
        border-radius: 0.3em;
        transition: all 0.4s;
    }

</style>
